/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useNavigate, useLocation } from 'react-router-dom'
import { FingerPrintIcon, /* PlusCircleIcon, */ ShieldCheckIcon, SwitchHorizontalIcon } from '@heroicons/react/solid'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import styled from 'styled-components'
import { FrameInset, Tabs, Theme } from '@nexigendigital/nxui'

import Profile from 'containers/account/components/profile'
/* import AdditionalUsers from 'containers/account/components/additionalUsers' */
import EmailLog from 'containers/account/components/emailLog'
import TwoFactor from 'containers/account/components/twoFactor'
import Details from 'containers/account/components/details'
import Security from 'containers/account/components/security'

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function AccountContainer() {
    const navigate = useNavigate()
    const location = useLocation()

    /*   JSX FUNCTIONS
    **********************************************************************************************************/
    function setInitialTab() {
        switch (location.pathname) {
            case '/account/emails':
                return 'Email Log'

            case '/account/security':
                return 'Security'

            default:
                return 'Two Factor Authentication'
        }
    }

    /*   RENDER COMPONENT
    **********************************************************************************************************/
    return (
        <>
            <FrameInset
                inset={'split'}
                location={{ pathname: '/Account' }}
                left={{
                    render: <Profile />
                }}
                right={{
                    render: <Account.Base>
                        <Details />
                        <Account.Tabs initialTab={setInitialTab()} tabs={[
                            {
                                icon: FingerPrintIcon,
                                label: 'Two Factor Authentication',
                                render: <TwoFactor />,
                                location: () => navigate('/account/twofactor', { replace: true })
                            }, {
                                icon: ShieldCheckIcon,
                                label: 'Security',
                                render: <Security />,
                                location: () => navigate('/account/security', { replace: true })
                            }, /* {
                                icon: PlusCircleIcon,
                                label: 'Users',
                                render: <AdditionalUsers />
                            }, */ {
                                icon: SwitchHorizontalIcon,
                                label: 'Email Log',
                                render: <EmailLog />,
                                location: () => navigate('/account/emails', { replace: true })
                            }
                        ]} />
                    </Account.Base>
                }}
            />
        </>
    )
}

/**********************************************************************************************************
*   STYLE
**********************************************************************************************************/
const Account = {
    Base: styled.section`
        margin-bottom: 40px;

        ${props => (Theme.Functions.mediaBreakDown(props.theme['breakpoints-xl']))} {
            margin-top: 16px;
        }

        ${props => (Theme.Functions.mediaBreakDown(props.theme['breakpoints-lg']))} {
            margin-bottom: 80px;
        }
    `,
    Tabs: styled(Tabs)`
        width: 100%
    `
}

export { AccountContainer as Account }
